//      

                                                  
                                                      
import Filter from "../components/Filter";
                                    
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {resetPage, setCategory, setMenu} from "../actions/filter";

function mapStateToProps(state                  , ownProps             ) {
	return {
		isSelected: state.filter.showMenu === "FILTER",
		availableCategories: state.filter.filterStats.categories,
		selectedCategory: state.filter.filter.selectedCategory
	};
}

function mapDispatchToProps(dispatch          , state                  ) {
	return {
		closeCalculator: () => dispatch(setMenu()),
		setCategory: (key         = {}) => {
			dispatch(resetPage());
			dispatch(setCategory(key));
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Filter));
